import { createContext } from "react";

import { noopLogger } from "./builtinLoggers";
import { ILogger } from "./ILogger";

export const LoggerContext = createContext<ILogger>(noopLogger);
